export default __webpack_public_path__ + "static/media/01.83413c70.jpg";